import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const fetchStatistics = createAsyncThunk(
  'organizationStatistics/fetchData',
  async (_params, { dispatch, rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/organization/statistics',
      method: 'GET'
    })
    if (!success) {
      dispatch(showHttpError(response))
      return rejectWithValue([])
    }

    return response
  }
)

const slice = createSlice({
  name: 'organizationStatistics',
  initialState: {
    available_seats: 0,
    occupancyRatio: null,
    occupancyCapacity: null,
    users: null,
    invitations: null,
    isLoading: true
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStatistics.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(fetchStatistics.fulfilled, (state, { payload }) => ({
      available_seats: payload.available_seats,
      occupancyRatio: payload.occupancy_ratio,
      occupancyCapacity: payload.occupancy_capacity,
      users: payload.users,
      invitations: payload.invitations,
      migrations: payload.migrations,
      isLoading: false,
    }))
    builder.addCase(fetchStatistics.rejected, (state) => {
      state.isLoading = false
    })
  }
})

export const statisticsSelector = ({ organizationStatistics }) => organizationStatistics
export const { reducer } = slice
